module.exports = __webpack_public_path__ + "img/service_2.383b37f.webp";